import { LftSkeleton, LftTypography } from '@lift/design-system-react-web/dist/components';
import { Curso } from '../../../../../models/usuario.model';
import { capitalizeFormatter } from '../../../../../utils/formatters/capitalize/capitalize.formatter';

export const NonLeadContent: React.FC<{ curso: Curso | null }> = ({ curso }) =>
  curso ? (
    <>
      <LftTypography component="caption">Curso</LftTypography>
      <LftTypography component="paragraph" fontWeight="medium">
        {capitalizeFormatter(curso.nome)}
      </LftTypography>
    </>
  ) : (
    <LftSkeleton shape="line" id="skeleton-nome-curso" />
  );
